export const inputType = {
  type: 'list' as const,
  objectType: 'artifactAlias' as const,
};
